export default [
  {
    path: 'cabang',
    name: 'spg point per branch',
    component: () => import('@/views/app/spg-point/current/page-per-branch.vue'),
    meta: { title: 'Poin Cabang' },
  },
  {
    path: 'spg',
    name: 'spg point per user',
    component: () => import('@/views/app/spg-point/current/page-per-spg.vue'),
    meta: { title: 'Poin SPG' },
  },
  {
    path: 'target',
    name: 'sale target list',
    component: () => import('@/views/app/sale-target/list/page-list.vue'),
    meta: { title: 'Target Penjualan' },
  },
  {
    path: 'riwayat',
    name: 'spg point history',
    component: () => import('@/views/app/spg-point/history/page-history.vue'),
    meta: { title: 'Riwayat Poin SPG' },
  },
  {
    path: 'pengaturan',
    name: 'spg point settings',
    component: () => import('@/views/app/spg-point/settings/page-settings.vue'),
    meta: { title: 'Pengaturan Poin' },
  },
]
